import { t } from "./i18n.ts";

const STORAGE_KEY = "earth-puzzle:v1:theme";

export type Theme = "dark" | "light";

function stored(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === "dark" || value === "light" ? value : null;
  } catch {
    return null; // 隱私模式讀不到就當作沒設定過
  }
}

export class ThemeToggle {
  private theme: Theme;
  private readonly buttons: HTMLButtonElement[];

  constructor(buttons: HTMLButtonElement[], signal?: AbortSignal) {
    this.buttons = buttons;
    // index.html 的首屏腳本已經決定過一次，這裡沿用同樣的結果，避免兩處判斷不一致
    this.theme = (document.documentElement.dataset.theme as Theme) ?? stored() ?? "dark";
    this.apply();
    for (const button of buttons) {
      button.addEventListener("click", () => this.toggle(), { signal });
    }
  }

  private apply(): void {
    document.documentElement.dataset.theme = this.theme;
    // 圖示顯示的是「切換後」的狀態：深色時給太陽（按了會變亮）
    for (const button of this.buttons) {
      const label = t(this.theme === "dark" ? "lightsOn" : "lightsOff");
      button.title = label;
      button.querySelector("use")?.setAttribute("href", this.theme === "dark" ? "#i-sun" : "#i-moon");
      // 選單項同時有圖示與文字，整顆 textContent 會把圖示蓋掉
      const text = button.querySelector<HTMLElement>(".label");
      if (text) text.textContent = label;
      else if (!button.querySelector("use")) button.textContent = label;
    }
  }

  /** 語言切換後按鈕文字要跟著換 */
  refresh(): void {
    this.apply();
  }

  toggle(): void {
    this.theme = this.theme === "dark" ? "light" : "dark";
    this.apply();
    try {
      localStorage.setItem(STORAGE_KEY, this.theme);
    } catch {
      // 存不了就只在本次瀏覽生效，不影響切換本身
    }
  }
}
